import React from "react";
import Card from "../FeaturedCard/FeaturedCard";
import useFetch from "../../hooks/useFetch";

const FeaturedProducts = ({ type }) => {
  const { data, loading, error } = useFetch(`/products?type=${type}`, 'NoToken');

  return (
    <section className="bg-light">
        <div className="container py-5">
            <div className="row text-center py-3">
                <div className="col-lg-6 m-auto">
                    <h1 className="feature-font">{type == 1 ? "Featured" : "Trending"} Product</h1>
                    <p>
                        
                    </p>
                </div>
            </div>
            <div className="row">
            {error
              ? "Something went wrong!"
              : loading
              ? "loading"
              : data?.map((item) => <Card item={item} key={item.id} />)}
            </div>
        </div>
    </section>
  );
};

export default FeaturedProducts;
{/*
<div className="featuredProducts">
      <div className="top">
        <h1>{type} products</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum
          suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan
          lacus vel facilisis labore et dolore magna aliqua. Quis ipsum
          suspendisse ultrices gravida. Risus commodo viverra maecenas.
        </p>
      </div>
      <div className="bottom">
        
      </div>
    </div> */}